import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import s from './ButtonImageText.module.scss';

const ButtonImageText = ({
    title = '',
    description = '',
    className = null,
    modifier = 'Primary',
    modifiers = [],
    icon = null,
    iconName = 'Arrow',
    url = null,
    target = null,
    rel = null,
    attrTitle = null,
    type = null,
    disabled = null,
    onClick = null,
    children,
    ...restProps
}) => {
    const isButton = !url;
    const Tag = isButton ? 'button' : 'a';
    const defaultType = isButton ? (type ? type : 'button') : null;

    const classes = classNames(
        className,
        s.Root,
        [s[`Root--${modifier}`]],
        modifiers.map((name) => s[`Root--${name}`]),
        { [s[`Root--${icon}`]]: icon },
        { [s['Root--Disabled']]: disabled }
    );

    delete restProps.menuIcon;
    delete restProps.fruitId;

    return (
        <Tag
            className={classes}
            href={url}
            target={target}
            rel={rel}
            title={attrTitle}
            type={defaultType}
            aria-disabled={disabled}
            disabled={disabled}
            onClick={onClick}
            {...restProps}>
            <div className={s.Container}>
                {children}
                <div className={s.TextWrapper}>
                    <span className={s.Title}>{title}</span>
                    <span className={s.Description}>{description}</span>
                </div>
            </div>
            <div className={s.IconWrapper}>
                <Icon name={iconName} className={s.IconHover} />
                <Icon name={iconName} className={s.Icon} />
            </div>
        </Tag>
    );
};

ButtonImageText.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.string,
    rel: PropTypes.string,
    attrTitle: PropTypes.string,
    type: PropTypes.string,
    modifier: PropTypes.string,
    modifiers: PropTypes.arrayOf(PropTypes.string),
    icon: PropTypes.oneOf([null, '', 'Arrow']),
    iconName: PropTypes.string,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
};

export default ButtonImageText;
